import React, { FC } from 'react';

interface OwnProps {
  id?: string;
  key?: string;
  onClick?: () => void | null;
}

export const DraggableIcon: FC<OwnProps> = () => {
  return (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="holder"
      width="16"
      height="16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" />
    </svg>
  );
};
